import { render, staticRenderFns } from "./ArticleIndex.vue?vue&type=template&id=8bc1a5ec&scoped=true"
import script from "./ArticleIndex.vue?vue&type=script&lang=js"
export * from "./ArticleIndex.vue?vue&type=script&lang=js"
import style0 from "./ArticleIndex.vue?vue&type=style&index=0&id=8bc1a5ec&prod&scoped=true&lang=css"
import style1 from "./ArticleIndex.vue?vue&type=style&index=1&id=8bc1a5ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc1a5ec",
  null
  
)

export default component.exports